import React from "react";
import styled from "@emotion/styled";
import moment from "moment";
import {
    color_text_default,
    color_text_light,
    color_shades_dark,
    color_colors_ocean,
    color_defaults_white,
    color_variants_ocean_light_1,
} from "../../../constants/colors";

interface MonthSelectorProps {
    selectedMonth: Date;
    onMonthChange: (month: Date) => void;
    disabled?: boolean;
}

const MonthSelector: React.FC<MonthSelectorProps> = ({ selectedMonth, onMonthChange, disabled }) => {
    // Generate current month + last 24 months (25 total)
    const months: { value: string; label: string; date: Date }[] = [];
    for (let i = 0; i < 25; i++) {
        const m = moment().subtract(i, "months").startOf("month");
        months.push({
            value: m.format("YYYY-MM"),
            label: m.format("MMMM YYYY"),
            date: m.toDate(),
        });
    }

    const currentValue = moment(selectedMonth).format("YYYY-MM");

    return (
        <Wrapper>
            <Label>Billing Month</Label>
            <Select
                value={currentValue}
                onChange={(e) => {
                    const found = months.find((m) => m.value === e.target.value);
                    if (found) onMonthChange(found.date);
                }}
                disabled={disabled}
            >
                {months.map((m) => (
                    <option key={m.value} value={m.value}>
                        {m.label}
                    </option>
                ))}
            </Select>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

const Label = styled.label`
    font-size: 12px;
    font-weight: 500;
    color: ${color_text_light};
    text-transform: uppercase;
    letter-spacing: 0.05em;
`;

const Select = styled.select`
    padding: 8px 12px;
    border: 1px solid ${color_shades_dark};
    border-radius: 4px;
    font-size: 14px;
    color: ${color_text_default};
    background: ${color_defaults_white};
    cursor: pointer;
    min-width: 200px;

    &:focus {
        outline: none;
        border-color: ${color_colors_ocean};
        box-shadow: 0 0 0 3px ${color_variants_ocean_light_1};
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

export default MonthSelector;
